// extracted by mini-css-extract-plugin
export var breadcrumb = "_1-3";
export var breadcrumbArrow = "_1-4";
export var breadcrumbs = "_1-0";
export var link = "_1-5";
export var sm = "_1-1";
export var xs = "_1-2";